import { useEffect, useState } from "react";
import { GameConfigContext, GamePlayerContext, LocalPlayerContext } from "../../../context/game-context";
import { Spinner } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch, useSelector } from "react-redux";
import { CheckActivation } from "@redux/actions/auth/user-activation.actions";
import { useParams } from "react-router-dom";
import { ResendActivation } from "@redux/actions/auth/user-activation.actions";
import { useAuthBasicService } from "../../../../blockhain/provider/initiate.provider";


export default function ActivationLink() {
    let { activationCode } = useParams();
    console.log("MASUP ACTIVATION LINK");
    const setLoading = GameConfigContext((state) => state.setLoading);

    const onRequest = useSelector((state) => state.UserActivation.onRequest)
    const activationState = useSelector((state) => state.UserActivation.activationState)
    const userData = useSelector((state) => state.UserActivation.data)
    const dispatch = useDispatch();

    const checkActivation = async () => {

        const checkActivation = await CheckActivation(activationCode);

        dispatch(checkActivation)
        console.log(checkActivation, "CHECK ACTIVATION");
        // setToken(token);
    }

    const updateLocalPlayerSetting = LocalPlayerContext((state) => state.updateLocalPlayerSetting);
    const setGamePlayerContext = GamePlayerContext((state) => state.setGamePlayerContext);

    const {
        isAuthenticated,
        user,
        setupAccountData
    } = useAuthBasicService();

    useEffect(() => {
        if (isAuthenticated) {
            updateLocalPlayerSetting({ displayName: user.name, ...user });
            setGamePlayerContext({ isAccountBinded: user.isAccountBinded, isProfileUpdated: user.isProfileUpdated })
            // add your logic here
            // console.log(isAuthenticated, "EFFECT AUTHENTICATED CHANGED")
        } else {
            // setUserLogged(null)
        }

    }, [isAuthenticated]);

    useEffect(() => {
        console.log(userData);
        if (activationState == "success") {
            setupAccountData(userData);
        }

    }, [activationState])

    const resendActivation = async () => {

        const resendActivation = await ResendActivation(activationCode);

        dispatch(resendActivation)
        // setToken(token);
    }

    useEffect(() => {
        setLoading(false, null);
        checkActivation();
    }, [])
    return (
        <>
            <div className="landing container-fluid">
                <div className="container">
                    <div className="row d-flex justify-content-center">
                        <div className='col-md-6'>
                            <div className='card' style={{ maxWidth: '500px' }}>
                                <div className='card-body'>
                                    {onRequest && <>
                                        <Spinner size='md' />
                                        <p className='text-center mt-2'>Sedang Memuat, Mohon Tunggu ...</p>
                                    </>}
                                    {(!onRequest && activationState == "success") &&
                                        <div>
                                            <FontAwesomeIcon icon="far fa-check-circle" className="text-primary mb-4" style={{ fontSize: '60px' }} />
                                            <h6>Selamat! Anda telah berhasil melakukan Aktivasi akun,
                                                sekarang anda dapat melakukan login melalui akun anda</h6>
                                            <p className="mt-3">
                                                <a href='/' className='btn btn-primary w-100'>OK, Eksplore Museum Virtual</a></p>
                                        </div>
                                    }
                                    {(!onRequest && activationState == "error") &&
                                        <div>
                                            <FontAwesomeIcon icon="far fa-circle-xmark" className="text-danger mb-4" style={{ fontSize: '60px' }} />
                                            <h6>Gagal! proses aktivasi akun anda gagal, klik dibawah
                                                untuk mengirimkan ulang link aktivasi.</h6>
                                            <p className="mt-3">
                                                <a href='#' onClick={resendActivation} className='btn btn-primary w-100'>Kirim ulang link Aktivasi</a></p>
                                        </div>
                                    }
                                    {(!onRequest && activationState == "resend_success") &&
                                        <div>
                                            <FontAwesomeIcon icon="fa fa-envelope-circle-check" className="text-primary mb-4" style={{ fontSize: '60px' }} />
                                            <h6>Pendaftaran hampir berhasil!
                                                Cek inbox pada e-mail anda untuk menemukan
                                                link aktivasi.</h6>
                                            <p className="mt-3">
                                                <a href='/' className='btn btn-primary w-100'>Ok</a></p>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
